import { render } from "./NotFoundView.vue?vue&type=template&id=537c9822&scoped=true"
const script = {}

import "./NotFoundView.vue?vue&type=style&index=0&id=537c9822&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537c9822"]])

export default __exports__